<template>
   <section class="subcategoryheading">
      <div class="container">
         <div class="subcategoryheading__title">
			 <div v-if="category.logo" class="subcategoryheading__logo">
			 	<img :src="category.logo" :alt="category.subTitle"/>
				 <p v-if="category.slogan">{{category.slogan}}</p>
			 </div>
			 <h2 v-else>{{ category.subTitle }}</h2>
            <span>{{ category.subInfo }}</span>
         </div>
      </div>
      <div class="subcategoryheading__img" v-bind:style="{ background: 'url(' + category.subImage + ')' + 'no-repeat center center' }"></div>
      <div class="subcategoryheading__content">
         <p>{{ category.subDescription }}</p>
      </div>
   </section>

</template>

<script>

   export default {
      name: 'subCategoryHeading',
      props: ['category'],
   }
</script>
